import { render, staticRenderFns } from "./Hd.vue?vue&type=template&id=72ce5177&"
import script from "./Hd.vue?vue&type=script&lang=ts&"
export * from "./Hd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports